/**
 * Column visibility for list pages, configured in Account > Settings
 * (alv_settings with topic = 2, grouped by category name and setting name).
 *
 * Columns default to visible when the settings are not loaded yet or the
 * column has no setting, so this must stay in line with the DB defaults.
 *
 * @param {Object} settings - getPublishingSettings / getLabelSettings from the store
 * @param {string} categoryName - alv_settings_categories.name
 * @param {string} groupName - alv_settings.name
 * @param {string} settingKey - alv_settings.option1 of the column
 * @returns {boolean}
 */
export function isListColumnVisible(settings, categoryName, groupName, settingKey) {
    const category = settings && settings[categoryName]
    const columnSettings = category && category[2] && category[2][groupName]
    if (!Array.isArray(columnSettings)) {
        return true
    }

    const setting = columnSettings.find(s => s.option1 === settingKey)
    if (!setting) {
        return true
    }

    const currentValue = setting.value !== null ? setting.value : setting.default
    return currentValue === '1'
}
